import { getUkDateString } from '../helpers/dateHelpers';
import { SidebarTable } from './SidebarTable';
import { RevisionDto } from '../../designs/edit-pdf-details/RevisionDto';
import styled from 'styled-components/macro';

type Props = {
  revisions: Array<RevisionDto>;
};

export const RevisionBox = ({ revisions }: Props) => {
  return (
    <StyledSidebarTable>
      <tbody>
        <RevisionRow revision={revisions[0]} />
        <RevisionRow revision={revisions[1]} />
        <RevisionRow revision={revisions[2]} />
      </tbody>
    </StyledSidebarTable>
  );
};

const RevisionRow = ({ revision }: { revision?: RevisionDto }) => {
  const { code, date, initials, description } = revision || { code: '', date: '', initials: '', description: '' };
  return (
    <>
      <tr>
        <td>{code}</td>
        <td>{date ? getUkDateString(new Date(date)) : ''}</td>
        <td>{initials}</td>
      </tr>
      <tr>
        <td colSpan={3}>{description}</td>
      </tr>
    </>
  );
};

const StyledSidebarTable = styled(SidebarTable)`
  td {
    overflow: hidden;
  }
`;
